<template>
	<div>
		<v-layout class="p-4 border-bottom-light-grey min-height-57px">
			<v-flex md5 class="font-level-3-bold my-auto">
				<span class="detail-svg-icon mr-2">
					<!--begin::Svg Icon-->
					<inline-svg :src="$assetURL('media/custom-svg/reservation-color.svg')" />
					<!--end::Svg Icon-->
				</span>
				{{ getTitle() }}
			</v-flex>
		</v-layout>
		<template v-if="contentLoading">
			<Loading />
		</template>
		<div v-else class="overflow-y" style="max-height: calc(100vh - 306px)">
			<table width="100%" class="detail-table table-head-sticky">
				<thead>
					<tr>
						<th width="30" class="p-2 blue lighten-4 text-center"></th>
						<th width="60" class="p-2 blue lighten-4 text-center">#</th>
						<th width="250" class="p-2 blue lighten-4">Item</th>
						<th min-width="300" class="p-2 blue lighten-4">Description</th>
						<th width="120" class="p-2 blue lighten-4">UOM</th>
						<th width="120" class="p-2 blue lighten-4 text-center">Qty</th>
						<th width="150" class="p-2 blue lighten-4 text-center">Rate</th>
						<th width="160" class="p-2 blue lighten-4 text-right pr-5">Amount</th>
					</tr>
				</thead>
				<!-- <tbody v-if="line_items.length"> -->
				<template v-if="line_items.length">
					<tr>
						<td class="p-2 border-top-light-grey"></td>
						<td class="p-2 border-top-light-grey"></td>
						<td colspan="2" class="p-2 border-top-light-grey">
							<ShowValue :object="line_items_detail" object-key="free_text" label="free text"></ShowValue>
						</td>
						<td class="p-2 border-top-light-grey" valign="top">
							<ShowValue v-if="false" :object="line_items_detail" object-key="uom" label="uom"></ShowValue>
						</td>
						<td colspan="3" class="p-2 border-top-light-grey"></td>
					</tr>
					<Draggable
						tag="tbody"
						v-model="line_items"
						class="draggable-group"
						handle=".draggable-drag-icon"
						v-on:change="updateLineItem()"
					>
						<tr v-for="(row, index) in line_items" :key="index">
							<td class="p-2 border-top-light-grey text-center">
								<v-icon color="blue darken-4 " class="cursor-move draggable-drag-icon">mdi-drag</v-icon>
							</td>
							<td class="p-2 border-top-light-grey text-center">
								{{ index + 1 }}
							</td>
							<td class="p-2 border-top-light-grey">
								<ShowValue :object="row" object-key="product_name" label="product"></ShowValue>
							</td>
							<td class="p-2 border-top-light-grey">
								<ShowValue :object="row" object-key="description" label="description"></ShowValue>
							</td>
							<td class="p-2 border-top-light-grey">
								<ShowValue :object="row" object-key="uom" label="uom"></ShowValue>
							</td>
							<td class="p-2 border-top-light-grey text-center">
								{{ row.quantity ? row.quantity : 0 }}
							</td>
							<td class="p-2 border-top-light-grey text-center">
								<template v-if="row.is_price_changed">
									<v-icon color="red" size="12">mdi-circle</v-icon>
									({{ row.dprice ? `$${row.dprice}` : "$0" }})
								</template>
								{{ formatMoney(row.rate ? row.rate : 0) }}
							</td>
							<td class="p-2 border-top-light-grey text-right pr-5">
								<template v-if="line_items_detail.show_price">
									{{ formatMoney(row.total ? row.total : 0) }}
								</template>
							</td>
							<td class="p-2 border-top-light-grey" v-if="false">
								<!-- {{ row.recieved }} -->
								<InputEdit v-model="row.recieved" v-on:update="updateValue($event)"> </InputEdit>
								<div style="width: 60px" class="mx-auto" v-if="false">
									<TextInput v-model="row.recieved" hide-details class="mt-0"></TextInput>
									<div class="w-100 px-3 py-1">{{ row.recieved }}</div>
								</div>
							</td>
						</tr>
					</Draggable>
					<tfoot style="font-size: 14px">
						<tr>
							<td colspan="7" class="p-2 text-right"><b>Sub Total</b></td>
							<td class="p-2 text-right pr-5">
								<b>{{ formatMoney(line_items_detail.sub_total) }}</b>
							</td>
						</tr>
						<tr>
							<td colspan="7" class="p-2 text-right">
								<b
									>Discount ({{ line_items_detail.discount_value_type == 1 ? "$" : ""
									}}{{ line_items_detail.discount_value
									}}{{ line_items_detail.discount_value_type == 2 ? "%" : "" }})</b
								>
							</td>
							<td class="p-2 text-right pr-5">
								<b>{{ formatMoney(line_items_detail.discount_amount) }}</b>
							</td>
						</tr>
						<tr v-if="line_items_detail.tax_applied">
							<td colspan="7" class="p-2 text-right">
								<b>Tax {{ line_items_detail.tax_value }}%</b>
							</td>
							<td class="p-2 text-right pr-5">
								<b>{{ formatMoney(line_items_detail.tax_amount) }}</b>
							</td>
						</tr>
						<tr>
							<td colspan="7" class="p-2 text-right"><b>Adjustment</b></td>
							<td class="p-2 text-right pr-5">
								<b>{{ formatMoney(line_items_detail.adjustment) }}</b>
							</td>
						</tr>
						<tr>
							<td colspan="7" class="p-2 text-right green--text"><b>Grand Total</b></td>
							<td class="p-2 text-right green--text pr-5">
								<b>{{ formatMoney(line_items_detail.total) }}</b>
							</td>
						</tr>
					</tfoot>
				</template>
				<!-- </tbody> -->
				<tfoot v-else>
					<tr>
						<td colspan="5">
							<p class="m-0 row-not-found text-center py-3">
								<img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
								Uhh... There <span class="text-lowercase">are no {{ getTitle() }} at the moment.</span>
							</p>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>
<script>
import TextInput from "@/view/components/TextInput";
import InputEdit from "@/view/components/InputEdit";
import { GetLineItem } from "@/core/lib/quotation.lib";
import Loading from "@/view/components/Loading";
import ShowValue from "@/view/components/ShowValue";
import Draggable from "vuedraggable";
export default {
	props: {
		type: {
			type: String,
			default: null,
		},
		typeText: {
			type: String,
			default: null,
		},
		itemType: {
			type: String,
			default: null,
		},
		uuid: {
			type: String,
			default: null,
		},
		id: {
			type: Number,
			default: 0,
		},
		status: {
			type: String,
			default: "all",
		},
	},
	data() {
		return {
			contentLoading: false,
			line_items: [],
			line_items_detail: {
				total: 1111,
				sub_total: 1111,
				tax_type: 1,
				discount_type: 2,
				discount_value_type: 2,
				total_items: null,
				discount_value: 15,
				discount_amount: 10,
				tax_value: 7,
				taxable_amount: 0,
				tax_amount: 0,
				adjustment: 100,
				tax_applied: 1,
				gst: 0,
			},
			pageLoading: true,
		};
	},
	methods: {
		getTitle() {
			return "Line Items";
		},
		async getQuotationLineItems(id) {
			const param = {
				quotation: id,
				option: "line_items",
			};
			this.contentLoading = true;
			const data = await GetLineItem(param);
			this.contentLoading = false;
			this.line_items_detail = data.detail;
			this.line_items = data.line_items;
		},
		updateValue(value) {
			console.log("UpdateValue", value);
		},
		updateLineItem() {
			console.log(this.line_items);
		},
	},
	components: {
		TextInput,
		InputEdit,
		Draggable,
		Loading,
		ShowValue,
	},
	mounted() {
		if (this.id) {
			this.getQuotationLineItems(this.id);
		}
	},
};
</script>
